// extracted by mini-css-extract-plugin
module.exports = {"toolbarGroup":"ToolbarGroup_toolbarGroup__1gj5z"};